import { Demographics, IDemographicsResponse } from "../../classes/demographics";
import { BoundingBox } from "../../classes/interfaces";

export interface Neighbourhood {
  name: string;
  intro: string;
  transport: string;
  housing: string;
  character: string;
  services: string;
}

export interface NeighbourhoodInterface {
  geometry: number[][][];
  bounds: BoundingBox;
  demographics: IDemographicsResponse;
  city: string;
  neighbourhood: Neighbourhood;
}

export class NeighbourhoodDetails {
  paths: google.maps.LatLngLiteral[][];
  centre: google.maps.LatLngLiteral;
  bounds: BoundingBox;
  demographics: Demographics;
  city: string;
  neighbourhood: Neighbourhood;

  constructor(n: NeighbourhoodInterface) {
    this.paths = this._geometryToPath(n.geometry);
    this.centre = this._getBoundsCentre(n.bounds);
    this.bounds = n.bounds;
    this.demographics = new Demographics(n.demographics);
    this.city = n.city;
    this.neighbourhood = n.neighbourhood;
  }

  private _geometryToPath(geometry: number[][][]): google.maps.LatLngLiteral[][] {
    return geometry.map(pathSet => pathSet.map(coord => ({ lat: coord[0], lng: coord[1] })));
  }

  private _getBoundsCentre(box: BoundingBox): google.maps.LatLngLiteral {
    return {
      lat: (box.north + box.south) / 2,
      lng: (box.east  + box.west ) / 2
    };
  }
}